module.exports = __webpack_public_path__ + "img/kt2.2d72c3da.png";